<template>
  <div>
    <div v-if="editable" class="cms-content" v-on:click.prevent="edit()" v-html="content"></div>
    <div v-else class="cms-content" v-html="content"></div>

    <div ref="modal" v-if="editable && modalOpened" tabindex="-1" class="modal fade" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Edit Content - {{this.name}}</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <editor v-model="editing" :init="editorOptions"></editor>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" v-on:click.prevent="close()">Close</button>
            <button type="button" v-on:click.prevent="save()" class="btn btn-primary">Save changes</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" >
  .cms-content {
    min-height: 24px;
    position: relative;

    &:hover:before {
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      content: " ";
      border: 1px dashed rgba(0, 0, 0, 0.5);
      cursor: pointer;
      background: rgba(0, 0, 0, 0.1) url("/img/edit.png") no-repeat center center;
    }
  }

  .cms-content + .modal .modal-title {
    color: black;
  }
</style>
<script  >
  export default {
    props: ['name', 'editable', 'value'],
    mounted() {
      this.content = this.value;
      $(document).on('focusin', function(e) {
        if($(e.target).closest(".mce-window").length) {
          e.stopImmediatePropagation();
        }
      });
    },
    data() {
      return {
        modalOpened: false,
        content: '',
        editing: '',
        editorOptions: {
          browser_spellcheck: true,
          fontsize_formats: "8pt 10pt 12pt 14pt 18pt 24pt 36pt",
          forced_root_block: false,
          width: '100%',
          height: 270,
          plugins: "autolink link textcolor media code",
          menubar: false,
          toolbar1: ' styleselect | bold italic | sizeselect | fontselect |  fontsizeselect | alignleft aligncenter alignright alignjustify | forecolor | bullist numlist | link media | code',
        }
      }
    },
    methods: {
      save() {
        axios.post('/cms', {key: this.name, value: this.editing})
          .then((response) => {
            this.content = _.get(response, 'data.value');
            $(this.$refs.modal).modal('hide');
          });
      },
      edit() {
        this.modalOpened = true;
        this.editing = this.content;
        this.$nextTick(() => $(this.$refs.modal).modal('show'));
      },
      close() {
        this.editing = '';
        $(this.$refs.modal).modal('hide');
        this.$nextTick(() => this.modalOpened = false);
      }
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/cms.vue